import React from "react";
import uiStates from "../data/private/uiStates.json";

export default function InfoBanner({ stateKey, title, description }) {
  const state = uiStates[stateKey] || uiStates.info;
  const bannerTitle = title || state.title;
  const bannerDescription = description || state.description;

  return (
    <div className="card p-4">
      <p className="text-sm font-semibold text-slate-900">{bannerTitle}</p>
      <p className="mt-1 text-sm text-slate-600">{bannerDescription}</p>
    </div>
  );
}
